import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import useSWR from "swr";
import NotFoundPage from "../../../StoreComponents/NotFoundPage";
import { API } from "../../../StoreComponents/conflict";
import { PostStoreLog } from "../../../StoreComponents/hooks/useStoreLog";
import "./Suppliers.css";

const fetcher = (url) =>
  API.get(url, {
    headers: {
      search: `%%`,
    },
  }).then((res) => res.data.data);

const Suppliers = () => {
  const [pageIndex, setPageIndex] = useState(0);
  const [openElement, setOpenElement] = useState(false);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(50);
  // react hook form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const {
    register: register1,
    reset: reset1,
    formState: { errors: errors1 },
    handleSubmit: handleSubmit1,
  } = useForm();

  const {
    data: supplierData,
    error,
    mutate,
  } = useSWR(
    `store/settings/suppliers?page=${pageIndex}&limit=${limit}`,
    fetcher
  );

  const handleToggle = () => {
    if (!openElement) {
      setOpenElement(true);
    } else {
      setOpenElement(false);
    }
  };
  const [buttonLoading, setButtonLoading] = useState(false);
  // Post Suplier
  const onSubmit = (data) => {
    // console.log(data);
    setButtonLoading(true);
    API.post("store/settings/suppliers", data).then((res) => {
      // console.log(res);
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        PostStoreLog(1, "One supplier added");
        reset();
        setButtonLoading(false);
        mutate();
      } else {
        swal({
          title: "Opps !",
          text: `${res.data.message}`,
          icon: "warning",
          button: "Ok",
        });
        reset();
        mutate();
        setButtonLoading(false);
      }
    });
  };

  //  DELETE Suplier

  const deleteButtonHandler = (Id) => {
    // console.log(Id);
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        API.delete("store/settings/suppliers", {
          headers: {
            sup_id: Id,
          },
        }).then((res) => {
          if (res) {
            PostStoreLog(3, "One Supplier Delete");
            mutate();
          }
        });

        swal("Poof! Your imaginary file has been deleted!", {
          icon: "success",
        });
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };

  // Update Section
  const [getId, setGetId] = useState(null);

  //   Update supliers
  const onSubmitUpdate = (data) => {
    //console.log(data);

    API.put("store/settings/suppliers", data, {
      headers: {
        sup_id: getId,
      },
    }).then((res) => {
      //console.log(res.data);
      if (!res.data.error) {
        swal({
          title: "Thank You !",
          text: "Successfully Added",
          icon: "success",
          button: "Ok",
        });
        PostStoreLog(2, "Supplier update");
        window.$("#edit_suplier").modal("hide");
        reset1();
        window.location.reload();
        mutate();
        mutate1();
      } else {
        swal({
          title: "Opps !",
          text: `${res.data.message}`,
          icon: "warning",
          button: "Ok",
        });
        reset1();
        mutate();
        mutate1();
      }
    });
  };
  // Get suplier Id
  const handleUpdate = (updateId) => {
    // console.log(updateId);
    setGetId(updateId);
  };

  // get Category Data By ID
  const { data: suplierById, mutate: mutate1 } = useSWR(
    getId ? `store/settings/supplier/${getId}` : null,
    fetcher
  );
  console.log(getId);
  // { refreshInterval: 1000 }
  // Search Implement
  const handleSearch = async (e) => {
    e.preventDefault();
    const search = e.target.value;
    setSearch(search);
    let limit = search === "" ? 10 : 10000;
    const res = await API.get(
      `store/settings/suppliers?page=${0}&limit=${limit}`,
      {
        headers: {
          search: `%${search}%`,
        },
      }
    )
      .then((res) => res.data.data)
      .catch((error) => {
        if (error.name === "TypeError") {
          console.log("Data not found for the quary");
        }
      });
    if (res) {
      mutate(res, false);
    } else {
      mutate([], false);
    }
  };
  let counter = 1;

  console.log(supplierData);

  return (
    <>
      <Helmet>
        <title>Suppliers - BBA STORE</title>
        <meta name="description" content="Suppliers - BBA STORE" />
      </Helmet>
      <style type="text/css">
        {
          "table th ,table  td{ font-size:1.1rem} label{font-size:1rem !important}"
        }
      </style>

      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">Manage Suppliers/Persons</h3>
            <button
              onClick={handleToggle}
              type="button"
              className="btn px-3 btn-color_store"
            >
              <i className="fa fa-plus"></i>
              <span> Add Supplier</span>
            </button>
          </div>

          {/* Toogle Element */}
          <div
            className={openElement ? "category_store show" : "category_store"}
          >
            <div className="mx-auto text-center">
              <div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="container px-4">
                    <div className="row gx-5">
                      <div className="col-sm-12">
                        <div className="p-3 ">
                          {" "}
                          <input
                            {...register("supplier")}
                            placeholder="Enter English Name *"
                            type="text"
                            className="p-2  input-field-supp_store"
                            required
                          />{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <button
                    type="submit"
                    className="mt-3 px-3 btn btn-color_store"
                  >
                    <i className="fa fa-save"></i>
                    <span> Save</span>{" "}
                    {buttonLoading ? (
                      <div
                        style={{ width: "20px", height: "20px" }}
                        class="spinner-border ms-2  text-light"
                        role="status"
                      >
                        <span style={{}} class="visually-hidden ">
                          Loading...
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
          {/* Toogle Element */}

          <div
            className="my-4 table-container p-2"
            style={{ background: "white", borderRadius: "10px" }}
          >
            <div className="d-flex justify-content-between align-items-center search-div_store">
              <div className="col-12 col-md-6 col-lg-4">
                <p className="text-start mt-4 fs-6 text-black-50">
                  Show Entries
                  <select
                    onClick={(e) => {
                      setLimit(parseInt(e.target.value));
                    }}
                    className="ms-2 btn-outline-color "
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </p>
              </div>

              <div className="col-12 col-md-6 col-lg-4">
                <input
                  className="p-2 input-field w-100"
                  type="text"
                  name="Search"
                  onChange={(e) => handleSearch(e)}
                  placeholder="Search Suppliers"
                />
              </div>
            </div>
            {!supplierData ? (
              <NotFoundPage />
            ) : (
              <div className="table-responsive-sm data-table_store">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr className="tableColor">
                      <th colSpan="1">S/N</th>
                      <th colSpan="2">Data Name</th>
                      <th colSpan="1">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {supplierData.map((item) => (
                      <tr key={counter}>
                        <th>{counter++}</th>
                        <td colSpan="2">{item.supplier}</td>
                        <td className="text-center">
                          <button
                            data-bs-toggle="tooltip"
                            title="Edit"
                            type="button"
                            data-toggle="modal"
                            data-target="#edit_suplier"
                            onClick={() => {
                              handleUpdate(item.sup_id);
                            }}
                            className="btn btn-outline-color_store px-3 me-2"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                          <button
                            data-bs-toggle="tooltip"
                            title="Delete"
                            type="button"
                            onClick={() => {
                              deleteButtonHandler(item.sup_id);
                            }}
                            className="btn btn-danger px-3"
                          >
                            <i className="fa fa-trash-o"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {search.length > 0 ? (
              <div></div>
            ) : (
              <div className="text-end mt-4 mb-3">
                {pageIndex > 0 && (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex - 1)}
                  >
                    Previous
                  </button>
                )}

                {supplierData && supplierData.length === limit ? (
                  <button
                    type="button"
                    className="btn btn-outline-color_store px-4 me-2"
                    onClick={() => setPageIndex(pageIndex + 1)}
                  >
                    Next
                  </button>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Edit Suplier Modal */}
      <div id="edit_suplier" className="modal custom-modal fade" role="dialog">
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Suplier</h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              >
              </button>
            </div>
            <div className="modal-body text-start">
              <form onSubmit={handleSubmit1(onSubmitUpdate)}>
                <div className="container px-4">
                  <div className="row gx-5">
                    <div className="col-sm-12">
                      <div className="p-3 ">
                        {" "}
                        <input
                          {...register1("supplier")}
                          defaultValue={suplierById ? suplierById.supplier : ""}
                          type="text"
                          className="p-2  input-field-supp_store"
                          required
                        />{" "}
                      </div>
                    </div>
                    {/* <div className="col-sm-6">
                        <div className="p-3 "><input {...register1('supsulg')} defaultValue={suplierById?suplierById.SUPSULG:""}  type="text" className='p-2  input_field_category' />  </div>
                          </div> */}
                  </div>
                </div>

                <div className="submit-section">
                  <button
                    type="submit"
                    className="btn btn-color_store px-5 py-2 rounded"
                  >
                    Update
                  </button>

                  <button
                    type="button"
                    className="btn btn-color_store px-5 ms-1 py-2 rounded"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Suppliers;
